export const mockData = {
  hero: {
    headline: "Your Business, Powered Online.",
    subtext:
      "High-converting Websites & Mobile Apps built for gyms, salons, coaches, photographers, cafés and growing local brands.",
    cta: {
      primary: "Start Your Project",
      secondary: "View Portfolio",
      whatsapp: "https://wa.me/919805117900",
      bookCall: {
        label: "Free Strategy Call",
        link: "https://calendly.com/pranshik/build-your-mvp-discussion",
      },
    },
  },

  about: {
    name: "Pranshik",
    title: "Full-Stack Developer for Local Businesses",
    description:
      "I help local businesses grow with modern digital systems. Whether you're a gym, salon, photographer or a startup, I design and build fast, clean and conversion-focused digital experiences that increase enquiries, bookings and revenue.",
    expertise: [
      "React Native Apps",
      "Next.js Websites",
      "Growth-Focused Digital Strategy",
      "SEO & Online Presence Optimization",
    ],
  },

  services: [
    {
      id: 1,
      title: "Website Development",
      description:
        "Clean, modern and SEO-optimized websites designed to convert visitors into paying customers.",
      features: [
        "Lightning Fast Performance",
        "High Google Ranking Structure",
        "Conversion-Optimized Layouts",
        "Fully Custom Features",
      ],
    },
    {
      id: 2,
      title: "Mobile App Development",
      description:
        "High-performance iOS & Android apps built using React Native — perfect for memberships, bookings, communities and more.",
      features: [
        "Cross-Platform Development",
        "Native-Like Experience",
        "Push Notifications",
        "Offline & Secure Data Sync",
      ],
    },
    {
      id: 3,
      title: "Complete Digital Setup",
      description:
        "Your complete online identity in one package — designed for local businesses ready to scale.",
      features: [
        "Google Business Profile Setup",
        "SEO Optimization",
        "Social Profiles + Branding",
        "Analytics & Growth Insights",
      ],
    },
  ],

  socialProof: {
    highlights: [
      { id: 1, text: "Designed & Built 13+ Production Apps" },
      { id: 2, text: "2+ Years of Professional Development Experience" },
      { id: 3, text: "Worked With Founders & Brands Across India & Abroad" },
      {
        id: 4,
        text: "End-to-End Systems: App + Backend + Dashboard + Deployment",
      },
    ],

    stackCategories: [
      {
        id: 1,
        title: "Mobile Apps",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
        tools: [
          "React Native (Expo / Bare)",
          "TypeScript",
          "Redux Toolkit",
          "Secure Routing & Flows",
        ],
      },
      {
        id: 2,
        title: "Backend / APIs",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
        tools: [
          "Node.js + Express",
          "Firebase Cloud Functions",
          "MongoDB + Mongoose",
          "Realtime APIs & WebSockets",
        ],
      },
      {
        id: 3,
        title: "Cloud & Deployment",
        icon: "https://cdn.simpleicons.org/amazonaws/FF9900",
        tools: ["AWS S3 + CloudFront", "Firebase Hosting", "Railway", "Vercel"],
      },
      {
        id: 4,
        title: "Web & Dashboard",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
        tools: ["Next.js", "Tailwind + ShadCN", "Admin Dashboards", "Charts & Insights"],
      },
    ],
  },

  whyChooseMe: [
    {
      id: 1,
      title: "Fast Delivery",
      description:
        "Most projects go live within 7–21 days depending on complexity. No unnecessary delays.",
    },
    {
      id: 2,
      title: "Tailored For Your Business",
      description:
        "Every project is uniquely designed for your brand and optimized for conversions.",
    },
    {
      id: 3,
      title: "Local Business Understanding",
      description:
        "I understand the pain points of local businesses — getting enquiries, standing out, and building trust.",
    },
    {
      id: 4,
      title: "Lifetime Support",
      description:
        "You get long-term support & quick help whenever you need changes, updates or improvements.",
    },
  ],

  portfolio: [
    {
      id: 1,
      title: "Modern Gym Website",
      category: "Fitness",
      description:
        "A high-impact website designed to increase memberships, bookings and brand presence.",
      features: [
        "Class Scheduling",
        "Membership Plans",
        "Trainer Profiles",
        "Lead Form + WhatsApp Automation",
      ],
      image:
        "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80",
    },
    {
      id: 2,
      title: "Salon Booking Website",
      category: "Beauty",
      description:
        "A clean and elegant salon website powered with online booking and service browsing.",
      features: [
        "Service Menu",
        "Booking System",
        "Staff Profiles",
        "Gallery Showcase",
      ],
      image:
        "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=800&q=80",
    },
    {
      id: 3,
      title: "Photography Portfolio",
      category: "Photography",
      description:
        "A premium portfolio system built to showcase photography work and capture bookings.",
      features: [
        "High-Quality Gallery",
        "Package Pricing",
        "Client Area",
        "Smart Contact Form",
      ],
      image:
        "https://images.unsplash.com/photo-1542038784456-1ea8e935640e?w=800&q=80",
    },
    {
      id: 4,
      title: "Restaurant Website",
      category: "Food & Beverage",
      description:
        "A visually rich website with menu browsing, online ordering and reservation system.",
      features: [
        "Interactive Digital Menu",
        "Online Ordering",
        "Table Reserve System",
        "Review Showcase",
      ],
      image:
        "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&q=80",
    },
  ],

  testimonials: [
    {
      id: 1,
      name: "Rahul Sharma",
      business: "FitZone Gym",
      rating: 5,
      text: "Our leads increased massively after the new website went live. Clean design, fast delivery and the perfect booking workflow.",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Rahul",
    },
    {
      id: 2,
      name: "Priya Mehta",
      business: "Glamour Salon",
      rating: 5,
      text: "Beautiful design, fast load time and our clients love the booking system. Amazing experience!",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Priya",
    },
    {
      id: 3,
      name: "Amit Patel",
      business: "Capture Moments",
      rating: 5,
      text: "Exactly what I wanted — a premium portfolio that makes my photography look world-class. Bookings went up too.",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Amit",
    },
    {
      id: 4,
      name: "Sneha Gupta",
      business: "UrbanBites Café",
      rating: 5,
      text: "End-to-end system delivered fast. Online orders increased right from launch!",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Sneha",
    },
    {
      id: 5,
      name: "Karan Malhotra",
      business: "LiftStrong",
      rating: 5,
      text: "App + backend + admin dashboard — fully functional and super clean. Great experience with Pranshik!",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Karan",
    },
    {
      id: 6,
      name: "Maya Desai",
      business: "Bloom Beauty",
      rating: 5,
      text: "Smooth process and a high-converting website. Exactly what a modern beauty brand needs.",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Maya",
    },
  ],

  contact: {
    email: "hey@pranshik.com",
    whatsapp: "+91 9805117900",
    whatsappLink: "https://wa.me/919805117900",
    social: {
      instagram: "https://instagram.com/pranshik_sharmaa",
      linkedin: "https://linkedin.com/in/pranshik",
      github: "https://github.com/pranshik18",
    },
  },
};
